import React, {Component, createRef} from 'react';
import styles from './FJPreviewVideo.module.less';
import FJPreviewTooContainer from "../container/FJPreviewTooContainer";
import FJToolbarContainer from "../../toolBar/container/FJToolbarContainer";
import FJPreviewMediaStatusContainer from "../container/FJPreviewMediaStatusContainer";
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import FJPreviewTipContainer from "../container/FJPreviewTipContainer";
import FJRatioStore from "../../../store/FJRatioStore";
import FJPreviewRatio from "./FJPreviewRatio";
import FJBorder from "./FJBorder";
import classNames from 'classnames'
import FJEventConstant from "../../../constant/FJEventConstant";

class FJPreviewVideo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      videoWidth: 0,
      videoHeight: 0,
      containerWidth: 0,
      containerHeight: 0,
      previewRatioWidth: 0,
      previewRatioHeight: 0,
      hasPreviewRatioTransition: false,
      hasPreviewRatioShown: false,
    };
    this.box = createRef();
    this.videoBox = createRef();
    this.mainCanvas = createRef();
    this.lastTime = 0;
    this.timer = null;
  };

  componentDidMount() {
    this._adaptScreen();
    this._updatePreviewRatio();
    window.addEventListener('resize', this._adaptScreen);
    let {initCanvas, updateCanvasSize} = this.props;
    let domCanvas = this.mainCanvas.current;
    let {width, height} = domCanvas.getBoundingClientRect();
    initCanvas(domCanvas, this.videoBox.current);
    updateCanvasSize({width, height});
    this._unsubscript = window.FJEvent.subscribe(FJEventConstant.UPDATE_CANVAS_SIZE, this._adaptScreen);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.height !== prevProps.height || this.props.ratioType !== prevProps.ratioType) {
      this._adaptScreen();
    }

    // 这里加入异步是因为资源面板展开/关闭有个300ms动画
    if (this.props.isResourceExpand !== prevProps.isResourceExpand) {
      setTimeout(() => {
        this._adaptScreen();
      }, 300);
    }

    if (this.props.previewRatioType !== prevProps.previewRatioType) {
      this._updatePreviewRatio();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._adaptScreen);
    this._unsubscript();
  }

  _updatePreviewRatio = () => {
    const containerSize = this._calcContainerSize();
    if(this.props.previewRatioType) {
      const previewRatio = FJRatioStore.ratioSizeWithRatioType(this.props.previewRatioType);
      let previewRatioSize = FJCoreUtil.fitSize(containerSize, previewRatio);
      let offset = Date.now() - this.lastTime;
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.setState({
        previewRatioWidth: previewRatioSize.width,
        previewRatioHeight: previewRatioSize.height,
        hasPreviewRatioTransition: offset < 150,
        hasPreviewRatioShown: true,
      });
    } else {
      this.lastTime = Date.now();
      this.timer = setTimeout(() => {
        this.setState({hasPreviewRatioShown: false});
      }, 150);
    }
    this.setState({
      containerWidth: containerSize.width,
      containerHeight: containerSize.height,
    });
  }

  _calcContainerSize = () => {
    const rect = this.box.current.getBoundingClientRect();
    const landRatioSize = FJRatioStore.ratioSizeWithRatioType(FJRatioStore.allRatioType().landscape);
    const boxSize = {width: rect.width, height: rect.height - 40 - 12};
    return FJCoreUtil.fitSize(boxSize, landRatioSize);
  };

  /**
   * @description video 适应屏幕尺寸
   * @private
   */
  _adaptScreen = () => {
    const ratioSize = FJRatioStore.ratioSizeWithRatioType(this.props.ratioType);
    const containerSize = this._calcContainerSize();
    const videoSize = FJCoreUtil.fitSize(containerSize, ratioSize);
    this.setState({
      videoWidth: videoSize.width,
      videoHeight: videoSize.height,
      containerWidth: containerSize.width,
      containerHeight: containerSize.height,
    }, () => {
      this.props.updateCanvasSize(videoSize);
    });
  };

  _onToolContainerMouseDown = (e) => {
    e.stopPropagation();
  };

  _adaptClick = (e) => {
    e.stopPropagation();
  };

  render() {
    let {
      videoWidth,
      videoHeight,
      containerWidth,
      containerHeight,
      previewRatioWidth,
      previewRatioHeight,
      hasPreviewRatioTransition,
      hasPreviewRatioShown,
    } = this.state;

    return (
      <div className={classNames(styles.preview, {[styles.expand]: this.props.isResourceExpand})}>
        <div className={styles.toolbar}>
          <FJToolbarContainer />
        </div>
        <div className={styles.box} ref={this.box}>
          <div className={styles.video_box} ref={this.videoBox} >
            <div className={styles.video_container}
                 style={{width: containerWidth, height: containerHeight}}
            >
              <FJPreviewRatio width={previewRatioWidth} height={previewRatioHeight} hasTransition={hasPreviewRatioTransition} isShow={hasPreviewRatioShown}/>
              { this.props.hasBorder && <FJBorder /> }
              <FJPreviewTipContainer />
              <div className={styles.adaption_box}
                   style={{height: videoHeight + 'px', width: videoWidth + 'px'}} onClick={this._adaptClick}>
                <canvas ref={this.mainCanvas}
                        style={{height: videoHeight + 'px', width: videoWidth + 'px'}}  />
                <FJPreviewMediaStatusContainer />
              </div>
            </div>
          </div>
          <div className={styles.tool_box}
               style={{width: containerWidth}}
          >
            <FJPreviewTooContainer />
          </div>
        </div>
      </div>
    )
  }
}

export default FJPreviewVideo;
